import React, { useId, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './DarkManDebtBadge.css';

export const DarkManDebtBadge: React.FC = () => {
  const id = useId();
  const [open, setOpen] = useState(false);
  const button = useRef<HTMLButtonElement>(null);
  const tooltip = useRef<HTMLSpanElement>(null);
  const [position, setPosition] = useState({ left: 8, top: 8 });
  useLayoutEffect(() => {
    if (!open || !button.current || !tooltip.current) return;
    const anchor = button.current.getBoundingClientRect();
    const size = tooltip.current.getBoundingClientRect();
    setPosition({ left: Math.max(8, Math.min(anchor.left, window.innerWidth - size.width - 8)),
      top: Math.max(8, Math.min(anchor.bottom + 4, window.innerHeight - size.height - 8)) });
    const dismiss = () => setOpen(false);
    const escape = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      dismiss();
    };
    window.addEventListener('resize', dismiss);
    window.addEventListener('scroll', dismiss, true);
    document.addEventListener('keydown', escape, true);
    return () => {
      window.removeEventListener('resize', dismiss);
      window.removeEventListener('scroll', dismiss, true);
      document.removeEventListener('keydown', escape, true);
    };
  }, [open]);
  return <span className="dark-man-debt" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
    <button ref={button} type="button" aria-label="Dark Man debt" aria-describedby={open ? id : undefined}
      aria-expanded={open} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)}
      onClick={event => { event.stopPropagation(); setOpen(true); }}
      onKeyDown={event => {
        event.stopPropagation();
        if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
      }}>
      <img src="/InvestigatorBadges/dark-man-debt.png" width="28" height="28" alt="" />
    </button>
    {open && createPortal(<span ref={tooltip} id={id} role="tooltip" className="dark-man-debt-tooltip" style={position}>
      This investigator accepted the Dark Man’s bargain at Wizard’s Hill, gaining $5 and 5 Clue tokens.
      {' '}When ‘Old Debts Come Due!’ resolves, indebted investigators are devoured and 3 doom tokens
      are added for each investigator devoured. All Dark Man debts are then cleared.
    </span>, document.body)}
  </span>;
};
